/**
 * JSON.stringify replacement that handles circular references
 * instead of throwing "TypeError: Converting circular structure to JSON".
 * Circular references are replaced with the string "[Circular]".
 */
export function safeStringify(value: unknown): string {
  const seen = new WeakSet()

  return JSON.stringify(value, (_key, val) => {
    if (typeof val === 'object' && val !== null) {
      if (seen.has(val)) {
        return '[Circular]'
      }
      seen.add(val)
    }
    return val
  })
}